'use client';

import { getIconByKey, IconToken } from '@1debit/icons';
import { LinkedIconProps } from 'libs/contentful/types';
import { pascalToSnake } from 'utils/formatters';
import Link from '../Link/Link';
import { icons } from '@1debit/chime-assets';
import { datadogRum } from '@datadog/browser-rum';
import { LabelPlacement } from 'types/constants';
import { cn } from 'utils/styles';

const LinkedIcon = ({ iconName, url, showLabel, label, labelPlacement }: LinkedIconProps) => {
  const hideLabel = !showLabel || labelPlacement === LabelPlacement.Hidden; // showLabel to be deprecated
  const realIconName = pascalToSnake(iconName);

  if (!(realIconName in icons)) {
    datadogRum.addError(`LinkedIcon Error: ${realIconName} is not a valid Icon.`);
  }

  const Icon = getIconByKey(realIconName as IconToken);

  return (
    <Link href={url} className={cn(labelPlacement === LabelPlacement.Top && 'flex flex-col-reverse items-center')}>
      {Icon && <Icon data-testid="linkedIcon" />}
      <span className={hideLabel ? 'sr-only' : 'font-sans font-medium'}>{label}</span>
    </Link>
  );
};

export default LinkedIcon;
